<template>
	<article class="collection">
		<page-header>
			<div class="collection__header">
				<p class="collection__header__total">{{ stats }}</p>
			</div>
		</page-header>
		<managing-section :is-table="true">
			<horizontal-search
				:block-elem="true"
				@search="search"
				@init="initPage"
			>
				<select-input
					ref="searchFlag"
					:default-select-value="searchFlagList[0].value"
					:select-list="searchFlagList"
					placeholder="입력하세요"
					@change="searchFlagChange"
				/>
				<select-input
					ref="rangeFlag"
					:use-period="true"
					:default-select-value="rangeFlagList[0].value"
					:select-list="rangeFlagList"
					@change="rangeFlagChange"
				/>
			</horizontal-search>
		</managing-section>
		<managing-section :is-table="true">
			<template slot="infoSection">
				<span class="section__info__left"></span>
				<div class="section__info__right">
					<div class="section__info__items">
						<selector
							ref="isDisplay"
							v-model="isDisplay"
							title="노출상태"
							:option-list="isDisplayList"
							@input="displayInput"
						/>
					</div>
				</div>
			</template>
			<table class="table-main collection__table">
				<thead>
					<tr>
						<th class="collection__table__order">순서</th>
						<th class="collection__table__code">컬렉션 번호</th>
						<th class="collection__table__date">등록일</th>
						<th>제목</th>
						<th class="collection__table__count">제품수</th>
						<th class="collection__table__count">조회수</th>
						<th class="collection__table__display">노출 상태</th>
						<th class="collection__table__period">노출일</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in tableData" :key="item.id">
						<td>
							<input-text
								mode="number"
								:prop-value="item.sort"
								:disabled="!item.isDisplay"
								class="collection__table__order__input"
								@input="numberInput(Number($event), item.id)"
							/>
						</td>
						<td>{{ item.code }}</td>
						<td>{{ item.createdAt }}</td>
						<td class="text-left collection__table__link">
							<router-link
								:to="`/operation/collection-update/${item.id}`"
								class="link"
								>{{ item.title }}</router-link
							>
						</td>
						<td class="text-right">{{ item.productCount }}</td>
						<td class="text-right">{{ item.hit }}</td>
						<td>{{ item.display }}</td>
						<td>{{ item.period }}</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				:total-item="totalItem"
				:limit="limit"
				:offset="offset"
				@to="paging"
			/>
		</managing-section>
	</article>
</template>
<script>
	import debounce from 'lodash/debounce';
	import isEmpty from 'lodash/isEmpty';
	import isEqual from 'lodash/isEqual';
	import moment from 'moment';
	import PageHeader from '@/components/PageHeader.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import Selector from '@/components/Selector.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import InputText from '@/components/InputText.vue';

	export default {
		name: 'CollectionList',
		components: {
			PageHeader,
			HorizontalSearch,
			SelectInput,
			Selector,
			ManagingSection,
			PaginationBox,
			InputText,
		},
		data() {
			return {
				stats: '',
				searchFlag: 'title',
				searchFlagList: [
					{ value: 'title', name: '제목' },
					{ value: 'idProduct', name: '제품 번호' },
					{ value: 'code', name: '컬렉션 번호' },
				],
				title: '',
				rangeFlag: 'created',
				rangeFlagList: [
					{ value: 'created', name: '등록일' },
					{ value: 'on', name: '노출일' },
				],
				DateMin: '',
				DateMax: '',
				isDisplay: null,
				isDisplayList: [
					{ value: null, name: '전체' },
					{ value: true, name: '노출' },
					{ value: false, name: '비노출' },
				],
				limit: 20,
				offset: 0,
				totalItem: 0,
				tableData: [],
			};
		},
		mounted() {
			this.init();
		},
		methods: {
			parseDate(ms, format = 'YYYY.MM.DD HH:mm', defaultValue = '-') {
				return ms ? moment(ms).format(format) : defaultValue;
			},
			searchFlagChange({ select, input }) {
				this.searchFlag = select;
				this.title = input;
			},
			rangeFlagChange({ select, from, to }) {
				this.rangeFlag = select;
				this.DateMin = from
					? moment(from, 'YYYY-MM-DD').format('x')
					: '';
				this.DateMax = to ? moment(to, 'YYYY-MM-DD').format('x') : '';
			},
			displayInput() {
				this.search();
			},
			setFilter() {
				const query = this.$route.query;
				if (isEmpty(query)) return;
				if (query.searchFlag) {
					this.$refs.searchFlag.selectModel = query.searchFlag;
					this.searchFlag = query.searchFlag;
				}
				if (query.title) {
					this.$refs.searchFlag.inputModel = query.title;
					this.title = query.title;
				}
				if (query.rangeFlag) {
					this.rangeFlag = query.rangeFlag;
					this.$refs.rangeFlag.selectModel = query.rangeFlag;
				}
				if (query.DateMin) {
					this.DateMin = query.DateMin;
				}
				if (query.DateMax) {
					this.DateMax = query.DateMax;
				}
				this.$refs.rangeFlag.changePeriod({
					from: query.DateMin
						? moment(query.DateMin, 'x').format('YYYY-MM-DD')
						: '',
					to: query.DateMax
						? moment(query.DateMax, 'x').format('YYYY-MM-DD')
						: '',
				});
				if (query.isDisplay) {
					this.isDisplay = query.isDisplay === 'true' ? true : false;
				}
				if (query.offset) {
					this.offset = Number(query.offset);
				}
			},
			setQuery() {
				const query = {
					searchFlag: this.searchFlag,
					title: this.title,
					rangeFlag: this.rangeFlag,
					DateMin: this.DateMin || null,
					DateMax: this.DateMax || null,
					isDisplay:
						typeof this.isDisplay === 'boolean'
							? String(this.isDisplay)
							: null,
					offset: String(this.offset),
				};
				if (isEqual(this.$route.query, query)) return;
				this.$router.replace({ query });
			},
			async getList() {
				this.tableData = [];
				const params = {
					offset: this.offset,
					limit: this.limit,
				};
				params[this.searchFlag] = this.title;
				if (this.DateMin) {
					params[`${this.rangeFlag}DateMin`] = this.DateMin;
				}
				if (this.DateMax) {
					params[`${this.rangeFlag}DateMax`] = moment(
						this.DateMax,
						'x'
					)
						.endOf('date')
						.format('x');
				}
				if (typeof this.isDisplay === 'boolean') {
					params.isDisplay = this.isDisplay;
				}
				const { data } = await this.$axiosAdmin2.get(
					'/v3/api/collection/list',
					{ params }
				);
				const stats = data.productCollectionCount;
				this.stats = `총 등록 (${Number(stats.totalCount)}) ㅣ 노출 (${Number(stats.displayCount)}) ㅣ 비노출 (${Number(stats.unDisplayCount)})`;
				this.totalItem = data.productCollectionList.contentTotal;
				this.tableData = data.productCollectionList.data.map(item => {
					item.createdAt = this.parseDate(item.createdAt);
					item.display = item.isDisplay ? '노출' : '비노출';
					const startOn = this.parseDate(
						item.startOn,
						undefined,
						null
					);
					const endOn = this.parseDate(item.endOn, undefined, null);
					item.period =
						startOn && endOn ? `${startOn} ~ ${endOn}` : `-`;
					return item;
				});
				this.setQuery();
			},
			async init() {
				this.setFilter();
				await this.getList();
			},
			paging({ offset }) {
				this.offset = offset;
				this.getList();
			},
			search() {
				this.offset = 0;
				this.getList();
			},
			initPage() {
				this.searchFlag = 'title';
				this.title = '';
				this.rangeFlag = 'created';
				this.DateMin = '';
				this.DateMax = '';
				this.$refs.searchFlag.init();
				this.$refs.rangeFlag.init();
				this.isDisplay = null;
				this.offset = 0;
				this.getList();
			},
			numberInput: debounce(async function (sort, id) {
				if (sort > 20) return;
				const params = { sort: sort || null };
				await this.$axiosAdmin2.put(
					`/v3/api/collection/${id}/sort`,
					params
				);
				await this.getList();
			}, 1000),
		},
	};
</script>
<style lang="scss" scoped>
	.collection__header {
		display: flex;
		align-items: center;
	}

	.collection__header__total {
		font-size: 1rem;
	}

	.collection__table__order,
	.collection__table__count,
	.collection__table__display {
		width: 80px;
	}

	.collection__table__code {
		width: 100px;
	}

	.collection__table__date {
		width: 140px;
	}

	.collection__table__period {
		width: 260px;
	}

	.collection__table__link {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.collection__table__order__input {
		padding: 0;
		border-radius: 0;
		text-align: center;
	}
</style>
